
<div class="modal-body loading text-center pb-4" *ngIf="isLoading">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  
  @if (!isLoading) {
    @if ((swiperIndex() >= activateBannerAtIndex())){
  
      <reservation-countdown
        [reservedSeconds]="reservedSeconds()"
        (onCountdownEnd)="countdownEnd($event)"
      >
        <div class="corp-color">
          @if (finalMultipleInscriptionsNum() > 1){
            {{ 'Inscription' | translate }} {{(swiperIndex() - activateBannerAtIndex() + 1)}} / {{finalMultipleInscriptionsNum()}}
          }
        </div>
      </reservation-countdown>
    }
  
    <div class="form-inscription">
  
        <swiper-container
            #swiper
            free-mode="false"
            allow-touch-move="false"
            navigation="false"
            slides-per-view="1"
            space-between="0"
            auto-height="true"
            (swiperslidechange)="onSlideChange($event)">
  
          @if (inscription.groups?.length){
              <swiper-slide>
                  <div class="ion-padding">
                      <app-cards-option-select
                              [options]="groupOptions"
                              (onDisabledClick)="onDisabledClick($event)"
                              (onSelect)="onGroupsSelect($event)"
                              [multiple]="inscription.groupsAreMultichoice"
                              [corpColor]="corpColor"
                      ></app-cards-option-select>
                  </div>
              </swiper-slide>
          }
  
          @if (inscription.multipleInscriptionsAtSameTime){
              <swiper-slide tabindex="-1">
                  <div class="ion-padding">
                      @if (responsibleCustomFields?.length){
                          <h2>{{ 'Modules.Inscriptions.Multi-inscription.ResponsibleData' | translate }}</h2>
                      }
  
                      @if (formGroup && formBuilder){
                         <app-custom-fields-form
                              [customFields]="responsibleCustomFields"
                              [formBuilder]="formBuilder"
                              [formGroup]="formGroup"
                              [submitAttempted]="submitted"
                              (priceChanged)="recalcPrice()">
                          </app-custom-fields-form>
                      }
  
                      <h3>{{ 'Modules.Inscriptions.Multi-inscription.NumberOfPeople' | translate }}</h3>
  
                      <p-selectButton
                          [options]="multipleInscriptionsNumOptions"
                          [(ngModel)]="multipleInscriptionsOption"
                          optionLabel="label"
                          optionValue="value"
                          [allowEmpty]="false"
                          optionDisabled="disabled"
                      />
  
                      @if (multipleInscriptionsOption() == null){
                          <br>
                          <p-inputNumber
                             [ngModel]="multipleInscriptionsNum()"
                              (ngModelChange)="onMultipleInscriptionsNumInput($event)"
                              [showButtons]="true"
                              [min]="1"
                              [max]="maxMultipleInscriptions()"
                          />
                      }
  
                      <div class="ms-1 rgpd d-flex align-items-start gap-3 mt-3">
                        <p-checkbox [(ngModel)]="termsAccepted" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="termsAcceptedChange($event)" [binary]="true" />
                        <small [innerHTML]="inscription.rgpd"></small>
                      </div>
                      <!--
                      @if (bonifications?.length > 0 && !inscriptionRegsCreated()){
                              <div class="col-12 col-md-6 d-flex flex-column mt-3">
                                  <div>{{ 'INSCRIPTIONS.Bonus' | translate }}</div>
  
                                  <p-dropdown
                                      [options]="bonifications"
                                      [ngModelOptions]="{standalone: true}"
                                      styleClass="w-100"
                                      [(ngModel)]="defaultBonification"
                                      optionValue="id"
                                      [filter]="true"
                                      [showClear]="true"
                                      [placeholder]="'INSCRIPTIONS.BonusPlaceholder' | translate"
                                      (ngModelChange)="recalcPrice()"
                                      appendTo="body"
                                      [overlayOptions]="{
                                          baseZIndex: 1055
                                      }"
                                  >
                                      <ng-template let-selected pTemplate="selectedItem">
                                          <div class="flex align-items-center gap-2">
                                              <div>{{ selected.name }} <b *ngIf="selected.discount">-{{ selected.discount | number:'1.0-2'}}%</b></div>
                                          </div>
                                      </ng-template>
                                      <ng-template let-x pTemplate="item">
                                          <div class="flex align-items-center gap-2">
                                              <div>{{ x.name }} <b *ngIf="x.discount">-{{ x.discount | number:'1.0-2'}}%</b></div>
                                          </div>
                                      </ng-template>
                                  </p-dropdown>
                              </div>
                          }
                      -->
                  </div>
              </swiper-slide>
          }
  
          @for (reg of inscriptionRegs; track $index) {
              <swiper-slide tabindex="-1">
                  @if (formGroup && formBuilder){
                      <form [formGroup]="formGroup" #form="ngForm">
                          <div>
                              <app-custom-fields-form
                                      [customFields]="reg.customFields"
                                      [formGroup]="formGroup"
                                      [formBuilder]="formBuilder"
                                      [submitAttempted]="submitted"
                                      (priceChanged)="recalcPrice()">
                              </app-custom-fields-form>
  
                              @for (g of reg.groups; track g.id) {
                                  @if (g.customFieldsValues?.length){
                                      <h3>{{g.name}}</h3>
                                  }
  
                                  <app-custom-fields-form
                                          [customFields]="g.customFieldsValues"
                                          [formGroup]="formGroup"
                                          [formBuilder]="formBuilder"
                                          [submitAttempted]="submitted"
                                          (priceChanged)="recalcPrice()">
                                  </app-custom-fields-form>
                              }
  
                              @if (recurrences?.length > 1){
                                  <div class="col-12 col-md-6 d-flex flex-column mb-3 mb-md-0">
                                      <div>{{ 'INSCRIPTIONS.PaymentType' | translate }}</div>
                                      <p-dropdown [options]="recurrences"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [(ngModel)]="finalRecurrence"
                                                  optionValue="type"
                                                  [filter]="true"
                                                  appendTo="body"
                                                  (ngModelChange)="recalcPrice()">
                                          <ng-template let-selected pTemplate="selectedItem">
                                              <div class="flex align-items-center gap-2">
                                                  <div>{{ ('INSCRIPTIONS.PAYMENT_RECURRENCES.' + selected.type) | translate }} <b *ngIf="selected.discount">-{{ selected.discount | number:'1.0-2'}}%</b></div>
                                              </div>
                                          </ng-template>
                                          <ng-template let-x pTemplate="item">
                                              <div class="flex align-items-center gap-2">
                                                  <div>{{ ('INSCRIPTIONS.PAYMENT_RECURRENCES.' + x.type) | translate }} <b *ngIf="x.discount">-{{ x.discount | number:'1.0-2'}}%</b></div>
                                              </div>
                                          </ng-template>
                                      </p-dropdown>
                                  </div>
                              }
  
                              @if (bonifications?.length > 0){
                                  <div class="col-12 col-md-6 d-flex flex-column">
                                      <div>{{ 'INSCRIPTIONS.Bonus' | translate }}</div>
  
                                      <p-dropdown [options]="bonifications"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [(ngModel)]="reg.bonificationId"
                                                  optionValue="id"
                                                  [filter]="true"
                                                  [showClear]="true"
                                                  appendTo="body"
                                                  [placeholder]="'INSCRIPTIONS.BonusPlaceholder' | translate"
                                                  (ngModelChange)="recalcPrice()">
                                          <ng-template let-selected pTemplate="selectedItem">
                                              <div class="flex align-items-center gap-2">
                                                  <div>{{ selected.name }} <b *ngIf="selected.discount">-{{ selected.discount | number:'1.0-2'}}%</b></div>
                                              </div>
                                          </ng-template>
                                          <ng-template let-x pTemplate="item">
                                              <div class="flex align-items-center gap-2">
                                                  <div>{{ x.name }}  <b *ngIf="x.discount">-{{ x.discount | number:'1.0-2'}}%</b></div>
                                              </div>
                                          </ng-template>
                                      </p-dropdown>
  
                                      @if (reg.showBonificationDocumentInput){
                                          <label class=" col-form-label font-w-600 mb-e mt-3">
                                              {{ 'INSCRIPTIONS.BonusDocument' | translate }} <span class="required_asterisk">*</span>
                                          </label>
  
                                          <div>
                                              <app-file-uploader
                                                category="inscriptionSent"
                                                [communityNameInput]="communityCode"
                                                [maxFiles]="5"
                                                [type]="1"
                                                [(files)]="reg.files"
                                                [class.invalid]="reg.bonificationDocumentInvalid"
                                                (filesChange)="getUploadedFile($event, reg)"
                                              />
  
                                          </div>
                                      }
                                  </div>
                              }
                          </div>
  
                          @if (!inscription.multipleInscriptionsAtSameTime) {
                            <div class="ms-1 rgpd d-flex align-items-start gap-3 mt-3">
                              <p-checkbox [(ngModel)]="termsAccepted" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="termsAcceptedChange($event)" [binary]="true" />
                              <small [innerHTML]="inscription.rgpd"></small>
                            </div>
                          }
                      </form>
                  }
              </swiper-slide>
          }
  
        </swiper-container>
    </div>
  
      <div class="prices">
          <div>
          @if (pricesLoading){
              <app-spinner size="s" color="#000000"></app-spinner>
          } @else {
  
              @if (prices?.price?.totalWithFee > 0 || prices?.priceWithoutDiscount?.totalWithFee > 0) {
                  @if (shouldShowPriceFromPrefix()) {
                    <span>{{ 'INSCRIPTIONS.BasePriceFromPrefix' | translate }} </span>
                  }
                  <app-price [price]="prices.price" [recurrence]="finalRecurrence" [priceWithoutDiscount]="prices.priceWithoutDiscount"/>
  
                  <!-- @if(prices.firstPayment.fee > 0) {
                  <div class="mt-2 enrollment">
                      <span>
                      {{ 'Fee' | translate }}:
                      <strong class="ms-1">{{ prices.firstPayment.fee | appCurrencyPipe }}</strong>
                      </span>
                  </div>
                  } -->
              } @else {
                  <strong>{{ 'Free' | translate }}</strong>
              }
  
              @if (showEnrollmentPriceBlock()) {
                  <app-price [price]="prices.enrollment"/>
              }
  
              @if (prices?.firstPayment?.taxAmount > 0) {
                  <div class="tax-included">
                  ({{ prices.firstPayment.taxName }} {{ 'Included' | translate | lowercase }})
                  </div>
              }
  
          }
          </div>
  
          <div class="d-flex align-items-center">
              @if (swiperIndex() > 0){
                  <a class="cursor-pointer d-flex me-3" (click)="back()" style="text-decoration: none;">
                      <i class="fa fa-arrow-left me-1" style="line-height: 1.5"></i> {{ 'Back' | translate }}
                  </a>
  
              }
<!--
            swiperIndex: {{swiperIndex()}}
            <br>
            finalMultipleInscriptionsNum: {{finalMultipleInscriptionsNum()}}
            <br>
            lastStepIndex: {{lastStepIndex()}}
            <br>
            activateBannerAtIndex: {{activateBannerAtIndex()}}
            <br>
-->
              @if (swiperIndex() < lastStepIndex()){
                  <button
                  class="buy-btn rounded"
                  [style]="'--corp-color-1:' +corpColor+ ';'"
                  [class.opacity]="!currentStepValid()"
                  (click)="continue()">
                      @if (!submitLoading){
                          {{ 'Continue' | translate }}
                      } @else {
                          <app-spinner size="s"></app-spinner>
                      }
                  </button>
              } @else if (formGroup){
                  <button
                  class="buy-btn rounded"
                  [style]="'--corp-color-1:' +corpColor+ ';'"
                  [class.opacity]="formGroup.invalid || submitLoading"
                  (click)="save()">
                      @if(!submitLoading){
                          {{ 'Send' | translate }}
                      } @else {
                          <app-spinner size="s"></app-spinner>
                      }
                  </button>
              }
          </div>
      </div>
  }
  
  
  